module.exports = __webpack_public_path__ + "img/ls_logo_header.a8373aa2.png";